import ViewAllQuestionsMobileViewContainer from "./Containers/ViewAllQuestionsMobileViewContainer";
export default ViewAllQuestionsMobileViewContainer;
